import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

@Component({
  selector: 'v-product-section',
  templateUrl: './product-section.component.html',
  styleUrls: ['./product-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductSectionComponent implements OnInit {
  @Input() title;
  @Input() content;
  @Input() list;
  @Input() link;
  @Input() sectionType;
  @Input() subtitle;
  safeContent: SafeHtml;

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this.safeContent = this.sanitizer.bypassSecurityTrustHtml(this.content)
  }

}
